var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.008,
    height: 18.864,
    viewBox: "0 0 22.008 18.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-history",
    d: "M14.076,4.5a9.433,9.433,0,0,0-9.432,9.432H1.5l4.077,4.077.073.147,4.234-4.223H6.74A7.371,7.371,0,1,1,8.9,19.109L7.411,20.6A9.429,9.429,0,1,0,14.076,4.5ZM13.028,9.74v5.24l4.485,2.662.755-1.268L14.6,14.194V9.74Z",
    transform: "translate(-1.5 -4.5)",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIconWhite);
export default __webpack_public_path__ + "static/media/clock-icon-white.837ba8dc945c3a3c7f249517ab9592a2.svg";
export { ForwardRef as ReactComponent };